import { create } from 'zustand'

type ProductsLoadingStoreType = {
  // True while a filter/search navigation is in flight, so the products area can show its skeleton
  // even though a search-param navigation doesn't trigger the route-level loading.tsx.
  pending: boolean
  setPending: (pending: boolean) => void
}

const useProductsLoadingStore = create<ProductsLoadingStoreType>(set => ({
  pending: false,
  setPending: (pending: boolean) => set({ pending })
}))

export default useProductsLoadingStore
